import { type Components, type Theme } from "@mui/material/styles";

import { breakpoints } from "../breakpoints";

export const container: Components<Theme>["MuiContainer"] = {
  styleOverrides: {
    root: ({ theme }) => ({
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    }),
    maxWidthXs: {
      maxWidth: "375px",
      [`@media (min-width:${breakpoints.values.sm}px)`]: {
        maxWidth: "375px",
      },
    },
    maxWidthSm: {
      maxWidth: "768px",
      [`@media (min-width:${breakpoints.values.md}px)`]: {
        maxWidth: "768px",
      },
    },
    maxWidthMd: {
      maxWidth: "1024px",
      [`@media (min-width:${breakpoints.values.lg}px)`]: {
        maxWidth: "1024px",
      },
    },
    maxWidthLg: {
      maxWidth: "1366px",
      [`@media (min-width:${breakpoints.values.xl}px)`]: {
        maxWidth: "1366px",
      },
    },
    maxWidthXl: {
      maxWidth: "1920px",
      [`@media (min-width:1920px)`]: { maxWidth: "1920px" },
    },
  },
};
